// extracted by mini-css-extract-plugin
export default {"content-container":"CardError_content-container__seNru","heading-section":"CardError_heading-section__u10dd"};